import React from 'react';

const EditIcon = ({ width = 16, height = 17, fill = "#F9A101"}) => (
  <svg width={width} height={height} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.617 1.35537C11.444 0.528679 12.7844 0.528679 13.6114 1.35537L15.1447 2.8887C15.9714 3.71564 15.9714 5.05611 15.1446 5.88313L5.67592 15.3518C5.57189 15.4559 5.43796 15.5248 5.29284 15.549L1.05754 16.2549C0.579787 16.3345 0.165593 15.9203 0.245219 15.4425L0.951101 11.2072C0.975288 11.0621 1.04421 10.9282 1.14824 10.8242L10.617 1.35537ZM9.64335 4.32435L2.30607 11.6624L1.79993 14.6996L4.83721 14.1935L12.1744 6.85535L9.64335 4.32435ZM12.5629 2.30802C12.2856 2.07918 11.8746 2.09443 11.6152 2.35371L10.6414 3.32635L13.1724 5.85735L14.1463 4.88493C14.3797 4.65144 14.4154 4.29513 14.2534 4.02412L14.1921 3.93723L14.1464 3.88689L12.6132 2.35371L12.5629 2.30802Z"
      fill={fill}
    />
  </svg>
);

export default EditIcon;
